import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorReturnHeaderSummarySearch = () => {
  const returnHeaderSummarySearch = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/transaction-retur-header/retur-summary', payload, (response) => {
      if (response.status_code === 200) {
        if (response.data) {
          callback(response.data)
        } else {
          callback(null)
        }
      }
      loading(false)
    })
  }, [])

  return { returnHeaderSummarySearch }
}

export default InteractorReturnHeaderSummarySearch
